import { Container, Row, Col } from "react-bootstrap";
import Summary from '../../components/summary';
import TitleSummary from '../../components/titlesumary';
import SocialIcons from '../../components/socialicons';
import Skills from "../../components/skills";

const About = () => {
    return (
      <Container className="my-5">
        <Row className="justify-content-center">
          <Col md={8} className="text-center text-color-site text-font-family">

            <TitleSummary />

            <div className="my-4 text-start">
              <Summary />
            </div>

            {/* Sessão de Skills */}
            <div className="my-5">
              <Skills /> {/* Agora com carrosséis separados por categoria */}
            </div>

            {/* Social Icons */}
            <div className="social-links mb-4 social-padding">
              <SocialIcons />
            </div>

          </Col>
        </Row>
      </Container>
    )
}

export default About;
